module.exports = __webpack_public_path__ + "static/media/targetsector.33eb5ab3.svg";